import { FC, useCallback, useMemo } from 'react'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { startLinkageSessionActionCreator } from 'actions/linkageActions'
import { accountActionsMap } from 'helpers/linkageHelpers'
import { createProviderSelector, MixedAccountsTableItem } from 'selectors/linkageSelectors'
import { ModifyFloatingPaneAction } from 'actions/floatingPanesActions'

type AccountActionUpdateHandlerProps = {
  accountInfo: MixedAccountsTableItem
  kind: 'retry' | 'update_credentials' | 'update_manual_account'
}

export const AccountActionUpdateHandler: FC<AccountActionUpdateHandlerProps> = (props) => {
  const { accountInfo, children, kind } = props
  const { providerAccount, type, account, providerAccountState } = accountInfo
  const {
    link_status = false,
    cid: accountCid = null,
  } = account || {}
  const {
    cid: providerAccountCid = null,
  } = providerAccount || {}
  const { actions } = providerAccountState

  const cid = type === 'manual' ? accountCid : providerAccountCid

  const providerSelector = useMemo(createProviderSelector, [])
  const provider = useStoreSelector((state) => !!providerAccount && providerSelector(state, { cid: providerAccount?.providerCid }))

  const dispatch = useStoreDispatch()

  const handleClick = useCallback(() => {

    if (!cid) {
      return
    }

    if (!!provider && provider?.fast_link_forced) {
      return dispatch(new ModifyFloatingPaneAction({
        type: 'fastlink',
        mode: 'edit',
        provider_account_id: cid,
      }))
    }

    return dispatch(startLinkageSessionActionCreator.request({ cid }))
  }, [cid, provider, dispatch])

  const isExist = useMemo(() => {
    const { retry, update_credentials } = accountActionsMap(actions)
    const updateManualAccount = type === 'manual' && link_status === 'active'

    const isReady = kind === 'retry' && !!retry
    const isUpdateCredentials = kind === 'update_credentials' && !!update_credentials
    const isUpdateManualAccount = kind === 'update_manual_account' && updateManualAccount

    return isReady || isUpdateCredentials || isUpdateManualAccount
  }, [link_status, kind, actions, type])

  if (!isExist) {
    return null
  }

  return (
    <div onClick={ handleClick }>
      { children }
    </div>
  )
}
